"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APITaskSupplier = void 0;
const APITask_1 = require("./APITask");
const APITemplateSupplier_1 = require("./APITemplateSupplier");
class APITaskSupplier extends APITemplateSupplier_1.APITemplateSupplier {
    get(mainDef, mainContent = [], subDef, subContent) {
        return new APITask_1.APITask(this, this.translationsSection, mainDef, mainContent, subDef, subContent);
    }
    setTranslations(translations) {
        super.setTranslations(translations);
        if (this.translations) {
            this.translationsSection = this.translations.tasks;
        }
    }
}
exports.APITaskSupplier = APITaskSupplier;
